import '@fortawesome/fontawesome-pro/js/fontawesome.min.js';
import '@fortawesome/fontawesome-pro/js/brands.min.js';
import '@fortawesome/fontawesome-pro/js/light.min.js';
import '@fortawesome/fontawesome-pro/js/regular.min.js';
import 'isotope-layout/dist/isotope.pkgd.min.js';
import 'isotope-packery/packery-mode.pkgd.min.js';
import anime from 'animejs/lib/anime.min.js';
import ScrollTrigger from '@terwanerik/scrolltrigger';
import Swiper from 'swiper';
import SVGInject from '@iconfu/svg-inject';
import YTPlayer from 'youtube-player';
import GLightbox from 'glightbox';

let winWidth    = $(window).width(),
    winHeight   = $(window).height(),
    oWinHeight  = winHeight,
    breakpoints = {
      'xxs': true,
      'xs':  false,
      'sm':  false,
      'md':  false,
      'lg':  false,
      'xl':  false,
    };

function mobileCheck() {
  Object.keys(breakpoints).forEach(v => breakpoints[v] = false);

  breakpoints.xxs = true;

  if ( '390' <= winWidth ) {
    breakpoints.xs = true;
  }

  if ( '576' <= winWidth ) {
    breakpoints.sm = true;
  }

  if ( '768' <= winWidth ) {
    breakpoints.md = true;
  }

  if ( '992' <= winWidth ) {
    breakpoints.lg = true;
  }

  if ( '1200' <= winWidth ) {
    breakpoints.xl = true;
  }
}

mobileCheck();

$(window).resize(function() {
  winWidth  = $(window).width();
  winHeight = $(window).height();
  mobileCheck();

  if ((oWinHeight > winHeight) && !breakpoints.sm) {
    // keyboard detected?
    $('body').addClass('keyboard-active');
  } else {
    $('body').removeClass('keyboard-active');
  }
});

export default {
  init() {
    // JavaScript to be fired on all pages

    /**
     * DEV: Check what route we're on
     */
    // document.addEventListener('routed', e => {
    //   const routeName = e.detail.route;
    //   const routeEvent = e.detail.fn;
    //
    //   console.log(routeName, routeEvent);
    // });

    /**
     * Site navigation
     */

    let navActivated = function() {
      $('body').addClass('nav-active');
    },
    navDeactivated = function() {
      $('body').removeClass('nav-active');
    };

    $('#site-nav-trigger').on('click', function(e) {
      e.preventDefault();
      if (!$('body').hasClass('nav-active')) {
        navActivated();
      } else {
        navDeactivated();
      }
      $(this).blur();
    });

    $(document).on('keydown', function(e) {
      if (e.key == 'Escape') {
        navDeactivated();
      }
    });

    $(window).on('scroll', function() {
      let $header = $('#site-header'),
          $logo   = $('#logo-img');
  
      if (($(window).scrollTop() > 100) && !$header.hasClass('not-top') ) {
        $header.addClass('not-top');
        $logo.attr('src', $logo.data('logo-white'));
      } else if (($(window).scrollTop() <= 100) && $header.hasClass('not-top')) {
        $header.removeClass('not-top');
        if ($('body').hasClass('single-post')) {
          $logo.attr('src', $logo.data('logo')); 
        }
      }
    });

    // $('#menu-primary .menu-item-has-children').on('mouseenter', function(e) {
    //   let id = $(this).attr('id');
    //   anime.timeline({loop: false})
    //     .add({
    //       targets: '#' + id + ' > .sub-menu',
    //       width: ['35%', '85%'],
    //       opacity: [0, 1],
    //       zIndex: [-1, 1],
    //       easing: 'linear',
    //       duration: 200,
    //     })
    //     .add({
    //       targets: '#' + id + ' > .sub-menu > .menu-item',
    //       opacity: [0, 1],
    //       easing: 'linear',
    //       duration: 200,
    //       delay: (el, i) => 100 * i,
    //     }, 300);
    // }).on('mouseleave', function(e) {
    //   let id = $(this).attr('id');
    //   anime.timeline({loop: false})
    //     .add({
    //       targets: '#' + id + ' > .sub-menu > .menu-item',
    //       opacity: [1, 0],
    //       easing: 'easeInBack',
    //       duration: 100,
    //       delay: (el, i) => 100 * i,
    //     })
    //     .add({
    //       targets: '#' + id + ' > .sub-menu',
    //       width: ['85%', '35%'],
    //       opacity: [1, 0],
    //       zIndex: [1, -1],
    //       easing: 'easeInBack',
    //       duration: 100,
    //     }, 300);
    // });

    // $('ul.nav .menu-item-has-children .nav-expand').on('click', function(e) {
    //   e.preventDefault();

    //   let $this        = $(this),
    //       $thisLi      = $(this).parents('.menu-item'),
    //       $thisSubmenu = $thisLi.find('.sub-menu');

    //   $('ul.nav .menu-item-has-children .nav-expand').not($this).removeClass('active');

    //   $('ul.nav .sub-menu').not($thisSubmenu).slideUp(200);

    //   if (!$this.hasClass('active')) {
    //     $this.addClass('active');
    //   } else {
    //     $this.removeClass('active');
    //   }

    //   if ($thisSubmenu.is(':visible')) {
    //     $thisSubmenu.slideUp();
    //   } else {
    //     $thisSubmenu.slideDown();
    //   }
    // });

    /**
     * Full pic image size loading
     */
    let fullPicResizer = function() {
      $('.bg-img-sizer').each(function() {
        if (breakpoints.xs && $(this).data('size-xs')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-xs') + ')');
        }

        if (breakpoints.sm && $(this).data('size-sm')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-sm') + ')');
        }

        if (breakpoints.md && $(this).data('size-md')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-md') + ')');
        }

        if (breakpoints.lg && $(this).data('size-lg')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-lg') + ')');
        }

        if (breakpoints.xl && $(this).data('size-xl')) {
          $(this).attr('style', 'background-image:url(' + $(this).data('size-xl') + ')');
        }
      });
    };

    fullPicResizer();

    $(window).resize(function() {
      fullPicResizer();
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /**
     * Story video
     */

    if ($('.story-video-modal').length) {
      $('.story-video-modal').each(function() {
        let $videoEl  = $(this).find('.yt-player');

        if ($videoEl.length) {
          let videoElId = $videoEl.attr('id'),
              videoId   = $videoEl.data('video-id'),
              videoPlayer;

          videoPlayer = new YTPlayer(videoElId, {
            videoId: videoId,
            playerVars: {
              controls:       1,
              showinfo:       0,
              rel:            0,
              autoplay:       0,
              loop:           1,
              mute:           0,
              fs:             0,
              modestbranding: 1,
            },
          });

          if ('undefined' !== typeof videoPlayer) {
            $(this).on('shown.bs.modal', function() {
              videoPlayer.playVideo()
                .then(function () {
                  console.log('Playing videoPlayer'); // @todo: DEV only
                });
            }).on('hidden.bs.modal', function() {
              videoPlayer.stopVideo()
                .then(function () {
                  console.log('Stopping videoPlayer'); // @todo: DEV only
                });
            });
          }
        }
      });
    }


    /**
     * Creative showcase - Multimedia edition
     *
     * (Inside a function to reinstantiate after AJAX calls)
     */

    let multimediaModalVid = function() {
      if ($('.creative-multimedia-modal').length) {
        $('.creative-multimedia-modal').each(function() {
          // new bs.Modal(document.getElementById($(this).attr('id')));

          let $videoEl = $(this).find('.yt-player');

          if ($videoEl.length) {
            let videoElId = $videoEl.attr('id'),
                videoId   = $videoEl.data('video-id'),
                videoPlayer;

            videoPlayer = new YTPlayer(videoElId, {
              videoId: videoId,
              playerVars: {
                controls:       1,
                showinfo:       0,
                rel:            0,
                autoplay:       0,
                loop:           1,
                mute:           0,
                fs:             0,
                modestbranding: 1,
              },
            });

            if ('undefined' !== typeof videoPlayer) {
              $(this).on('shown.bs.modal', function() {
                $('.modal-backdrop').css('display', 'none'); // @todo dev
                videoPlayer.playVideo()
                  .then(function () {
                    console.log('Playing videoPlayer'); // @todo: DEV only
                  });
              }).on('hidden.bs.modal', function() {
                videoPlayer.stopVideo()
                  .then(function () {
                    console.log('Stopping videoPlayer'); // @todo: DEV only
                  });
              });
            }
          }
        });
      }
    };

    multimediaModalVid();


    /**
     * Creatives showcase (projects, case studies)
     */

    $('.filter-link').on('click', function(e) {
      e.preventDefault();

      let $filterLink = $(this),
          postId      = $filterLink.data('post'),
          selectedCat = $filterLink.data('cat'),
          action      = '',
          $canvas     = '',
          $loader     = '';

      $('.filter-link').not($filterLink).removeClass('active');
      $filterLink.addClass('active').blur();

      // Creatives showcase
      if ($('body').hasClass('single')) {
        $canvas = $('#creatives-showcase-canvas-container'),
        $loader = $('.creatives-showcase .loader'),
        action  = 'creatives';
      }

      // Work landing page - creative categories
      if ($('body').hasClass('page-work')) {
        $canvas = $('#page-work-creatives-canvas'),
        $loader = $('#creative-library .loader'),
        action  = 'creatives_by_cat';
      }

      $canvas.fadeOut(100, function() {
        $loader.css('opacity', 1);

        $.get(
          '/wp-admin/admin-ajax.php',
          {
            action:  action,
            post_id: postId,
            cat:     selectedCat,
          }
        )
        .done(function(data) {
          $loader.css('opacity', 0);
          $canvas.html(data).fadeIn();

          // reinstantiate lightbox for it to work on Ajax load
          const lightbox = GLightbox();

          // reinstantiate YT players, if any
          multimediaModalVid();
        });
      });

    });

    if ($('#creatives-filter').length) {
      $('#creatives-filter .filter-item:first-child .filter-link').trigger('click');
    }


    /**
     * Isotope grids
     */

    let $cardGrid = $('.card-grid'),
        numCols   = 3;

    $cardGrid.isotope({
      itemSelector: '.grid-item',
      percentPosition: true,
      masonry: {
        columnWidth: '.grid-sizer',
      },
    });

    /**
     * ANIME - Letter drop
     */

    let letterDrop = document.querySelector('.anime--letter-drop');

    if (letterDrop) {
      letterDrop.innerHTML = letterDrop.textContent.replace(/\S/g, '<span class="letter">$&</span>');

      const anime_LetterDrop = new ScrollTrigger();
      anime_LetterDrop.add(letterDrop, {
        once: false,
        offset: {
          viewport: {
            y: (trigger, frame, direction) => {
              frame,
              direction;

              return trigger.visible ? 0 : 0.25
            },
          },
        },
        toggle: {
          callback: {
            in: () => {
              anime.timeline({loop: false})
                .add({
                  targets: '.anime--letter-drop .letter',
                  scale: [4,1],
                  opacity: [0,1],
                  translateZ: 0,
                  easing: 'easeOutExpo',
                  duration: 950,
                  delay: (el, i) => 70 * i,
                });
            },
            out: () => { // same as the data-scroll-hideCallback
              anime.timeline({loop: false})
                .add({
                  targets: '.anime--letter-drop .letter',
                  opacity: 0,
                  easing: 'easeOutExpo',
                  duration: 950,
                });
            },
          },
        },
      });
    }

    /**
     * ANIME - Color fade in
     * (@todo: Must be a better way to do this with multiple selectors)
     */

    let colorFadeIn        = document.querySelector('.anime--color-fadein'),
        colorFadeIn2       = document.querySelector('h2 em'),
        colorFadeInOptions = {
          once: false,
          offset: {
            viewport: {
              y: (trigger, frame, direction) => {
                frame,
                direction;

                return trigger.visible ? 0 : 0.25
              },
            },
          },
          toggle: {
            class: {
                // don't use the default 'invisible' and 'visible' for this,
                // since we're just changing colors
                in: 'in-viewport',
                out: 'out-viewport',
            },
            callback: {
              in: () => {
                anime.timeline({loop: false})
                  .add({
                    targets: '.anime--color-fadein .letter, h2 em .letter',
                    color: ['#142b47', '#218be8'],
                    easing: 'easeOutExpo',
                    duration: 950,
                    delay: (el, i) => 70 * i,
                  });
              },
              out: () => { // same as the data-scroll-hideCallback
                anime.timeline({loop: false})
                  .add({
                    targets: '.anime--color-fadein .letter, h2 em .letter',
                    color: ['#218be8', '#142b47'],
                    easing: 'easeOutExpo',
                    duration: 950,
                  });
              },
            },
          },
        };

    if (colorFadeIn) {
      colorFadeIn.innerHTML = colorFadeIn.textContent.replace(/\S/g, '<span class="letter">$&</span>');

      const anime_ColorFadeIn = new ScrollTrigger();
      anime_ColorFadeIn.add(colorFadeIn, colorFadeInOptions);
    }

    if (colorFadeIn2) {
      colorFadeIn2.innerHTML = colorFadeIn2.textContent.replace(/\S/g, '<span class="letter">$&</span>');

      const anime_ColorFadeIn2  = new ScrollTrigger();
      anime_ColorFadeIn2.add(colorFadeIn2, colorFadeInOptions);
    }

    /**
     * ANIME - Fade in down
     */

    let fadeInDown = document.querySelectorAll('.anime--fadeindown');

    if (fadeInDown) {
      // for (var i = 0, len = fadeInDown.length; i < len; i++) {
      // }
      //
      //
      const anime_FadeInDown = new ScrollTrigger();
      anime_FadeInDown.add(fadeInDown, {
        once: true,
        offset: {
          viewport: {
            y: (trigger, frame, direction) => {
              // frame,
              // direction;
              //
              // return trigger.visible ? 0 : 0.35
            },
          },
        },
        toggle: {
          callback: {
            in: () => {
              anime.timeline({loop: false})
                .add({
                  targets: '.anime--fadeindown',
                  opacity: [0,1],
                  translateY: ['-100px', 0],
                  easing: 'easeOutExpo',
                  duration: 2000,
                  delay: (el, i) => 120 * i,
                });
            },
          },
        },
      });
    }

    /**
     * ANIME - Letter grow
     */

    let letterGrow = document.querySelectorAll('.anime--letter-grow');

    if (letterGrow) {
      for (var i = 0, lglen = letterGrow.length; i < lglen; i++) {
        letterGrow[i].innerHTML = letterGrow[i].textContent.replace(/\S/g, '<span class="letter">$&</span>');
      }

      const anime_LetterGrow = new ScrollTrigger();
      anime_LetterGrow.add(letterGrow, {
        once: false,
        offset: {
          viewport: {
            y: (trigger, frame, direction) => {
              frame,
              direction;

              return trigger.visible ? 0 : 0.25
            },
          },
        },
        toggle: {
          callback: {
            in: () => {
              anime.timeline({loop: false})
                .add({
                  targets: '.anime--letter-grow .letter',
                  scale: [4,1],
                  opacity: [0,1],
                  translateZ: 0,
                  easing: 'easeOutExpo',
                  duration: 1400,
                  delay: (el, i) => 90 * i,
                });
            },
            out: () => { // same as the data-scroll-hideCallback
              anime.timeline({loop: false})
                .add({
                  targets: '.anime--letter-grow .letter',
                  opacity: 0,
                  easing: 'easeOutExpo',
                  duration: 950,
                });
            },
          },
        },
      });
    }

    /**
     * Footer logo mark
     */

    const anime_LogoMarkDraw = new ScrollTrigger();
    anime_LogoMarkDraw.add('#site-footer .logo-mark-inverse', {
      once: false,
      offset: {
        viewport: {
          y: (trigger, frame, direction) => {
            frame,
            direction;

            return trigger.visible ? 0 : 0.2
          },
        },
      },
      toggle: {
        callback: {
          in: () => {
            anime({
              targets: '#site-footer .logo-mark-inverse polygon',
              strokeDashoffset: [anime.setDashoffset, 0],
              easing: 'easeInOutSine',
              duration: 2500,
              delay: function(el, i) { return i * 250 },
              direction: 'alternate',
              loop: false,
              complete: function() {
                $('#site-footer .logo-mark-inverse').addClass('drawn');
              },
            });
          },
          out: () => { // same as the data-scroll-hideCallback
            $('#site-footer .logo-mark-inverse').removeClass('drawn');
          },
        },
      },
    });

    /**
     * Unversal loader
     */

    anime({
      targets: '.loader .logo-mark-inverse polygon',
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'easeInOutSine',
      duration: 1500,
      delay: function(el, i) { return i * 250 },
      direction: 'alternate',
      loop: true,
    });

    /**
     * Swipers
     */

    // Related posts

    new Swiper('.related-posts .swiper-container', {
      speed: 400,
      loop: true,
      slidesPerView: 1.1,
      spaceBetween: 30,
      centeredSlides: true,
      breakpoints: {
        992: { // lg+
          slidesPerView: 4.1,
        },
      },
    });

    $('.multimedia-card').each(function() {
      let $videoEl  = $(this).find('.yt-player');

      if ($videoEl.length) {
        let videoElId = $videoEl.attr('id'),
            videoId   = $videoEl.data('video-id'),
            videoPlayer;

        videoPlayer = new YTPlayer(videoElId, {
          videoId: videoId,
          playerVars: {
            controls:       0,
            showinfo:       0,
            rel:            0,
            autoplay:       0,
            loop:           1,
            mute:           0,
            fs:             0,
            modestbranding: 1,
          },
        });

        if ('undefined' !== typeof videoPlayer) {
          $(this).on('mouseover', function() {
            videoPlayer.playVideo()
              .then(function () {
                // console.log('Playing videoPlayer'); // @todo: DEV only
              });
          }).on('mouseout', function() {
            videoPlayer.stopVideo()
              .then(function () {
                // console.log('Stopping videoPlayer'); // @todo: DEV only
              });
          });
        }
      }
    });

    /**
     * SVG Inject
     * Replaces <img> serving SVGs into XHTML elements (.svg-inject class)
     */

    SVGInject(document.querySelectorAll('img.svg-inject'));

  },
};

window.onload = function() {
  $('body').addClass('loaded');
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js